<div class="dialog">
    <div class="dialog-title">
        <h6 class="pl-3">Change Your Avatar <img src="assets/svg/close-white.svg" alt="close" (click)="close()"></h6>
    </div>
    <div class="content text-center">
        <h6 class="mt-0">Upload or select your avatar</h6>
        <div class="upload-img-box " *ngIf="!fileUploaded">
            <div [formGroup]="demoForm" validate>

                <file-upload formControlName="files" accept=".jpg,.jpeg,.png,.svg">

                    <!-- <ng-template let-control="control" #button>
                    <i class="material-icons">
                            cloud_upload
                        </i>
                </ng-template> -->
                    <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder let-control="control" #button>
                        <span *ngIf="isFileDragDropAvailable">
                          <div _ngcontent-c1="" class="upload-input ng-trigger ng-trigger-zoomAnimation">
                            <div _ngcontent-c1="" class="icon ng-tns-c1-2 ng-star-inserted">
                                <svg _ngcontent-c1="" class="ng-tns-c1-2" viewBox="0 0 96 96">
                                <g _ngcontent-c1="" class="ng-tns-c1-2">
                                  <path _ngcontent-c1="" class="ng-tns-c1-2"
                                    d="M62.8,68.1c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6
                                     c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,0.9,0.6,1.5,0.6s1.1-0.2,1.5-0.6S62.8,68.7,62.8,68.1z M71.3,68.1
                                     c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.5,0.6C67.2,67,67,67.5,67,68.1c0,0.6,0.2,1.1,0.6,1.5
                                     s0.9,0.6,1.5,0.6c0.6,0,1.1-0.2,1.5-0.6C71.1,69.2,71.3,68.7,71.3,68.1z M75.5,60.7v10.6c0,0.9-0.3,1.6-0.9,2.2
                                     c-0.6,0.6-1.4,0.9-2.2,0.9H23.7c-0.9,0-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.4-0.9-2.2V60.7c0-0.9,0.3-1.6,0.9-2.2
                                     c0.6-0.6,1.4-0.9,2.2-0.9h14.1c0.5,1.2,1.2,2.2,2.3,3c1.1,0.8,2.3,1.2,3.7,1.2h8.5c1.3,0,2.6-0.4,3.7-1.2c1.1-0.8,1.9-1.8,2.3-3
                                     h14.1c0.9,0,1.6,0.3,2.2,0.9C75.2,59.1,75.5,59.8,75.5,60.7z M64.8,39.3c-0.4,0.9-1,1.3-2,1.3h-8.5v14.8c0,0.6-0.2,1.1-0.6,1.5
                                     c-0.4,0.4-0.9,0.6-1.5,0.6h-8.5c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.6-1.5V40.6h-8.5c-0.9,0-1.6-0.4-2-1.3
                                     c-0.4-0.9-0.2-1.6,0.5-2.3l14.8-14.8c0.4-0.4,0.9-0.6,1.5-0.6s1.1,0.2,1.5,0.6L64.3,37C65,37.7,65.1,38.4,64.8,39.3z"></path>
                                </g>
                              </svg>
                              <!-- <svg _ngcontent-hsg-c61="" viewBox="0 0 96 96"><g _ngcontent-hsg-c61=""><path _ngcontent-hsg-c61="" d="M40.5,66.8V39.3c0-0.4-0.1-0.7-0.4-0.9S39.6,38,39.3,38h-2.5c-0.4,0-0.7,0.1-0.9,0.4
                                s-0.4,0.5-0.4,0.9v27.5c0,0.4,0.1,0.7,0.4,0.9s0.5,0.4,0.9,0.4h2.5c0.4,0,0.7-0.1,0.9-0.4S40.5,67.1,40.5,66.8z M50.5,66.8V39.3
                                c0-0.4-0.1-0.7-0.4-0.9S49.6,38,49.3,38h-2.5c-0.4,0-0.7,0.1-0.9,0.4s-0.4,0.5-0.4,0.9v27.5c0,0.4,0.1,0.7,0.4,0.9s0.5,0.4,0.9,0.4
                                h2.5c0.4,0,0.7-0.1,0.9-0.4S50.5,67.1,50.5,66.8z M60.5,66.8V39.3c0-0.4-0.1-0.7-0.4-0.9S59.6,38,59.3,38h-2.5
                                c-0.4,0-0.7,0.1-0.9,0.4s-0.4,0.5-0.4,0.9v27.5c0,0.4,0.1,0.7,0.4,0.9s0.5,0.4,0.9,0.4h2.5c0.4,0,0.7-0.1,0.9-0.4
                                S60.5,67.1,60.5,66.8z M39.3,28h17.5l-1.9-4.6c-0.2-0.2-0.4-0.4-0.7-0.4H41.8c-0.3,0.1-0.5,0.2-0.7,0.4L39.3,28z M75.5,29.3v2.5
                                c0,0.4-0.1,0.7-0.4,0.9S74.6,33,74.3,33h-3.8v37c0,2.2-0.6,4-1.8,5.6S66,78,64.3,78H31.8c-1.7,0-3.2-0.8-4.4-2.3s-1.8-3.4-1.8-5.5
                                V33h-3.8c-0.4,0-0.7-0.1-0.9-0.4s-0.4-0.5-0.4-0.9v-2.5c0-0.4,0.1-0.7,0.4-0.9s0.5-0.4,0.9-0.4h12.1l2.7-6.5c0.4-1,1.1-1.8,2.1-2.5
                                s2-1,3.1-1h12.5c1,0,2.1,0.3,3.1,1s1.7,1.5,2.1,2.5l2.7,6.5h12.1c0.4,0,0.7,0.1,0.9,0.4S75.5,28.9,75.5,29.3z"></path></g></svg> -->
                              
                            </div>
                            <div class="text-center">
                                <img class="mb-2" src="assets/svg/upload-file.svg" alt="cube">
                                <br>                               
                            </div>         
                            <br>                                
                            <div class="upload-text ng-tns-c1-2 ng-star-inserted">                                                               
                                <b  class="center ng-tns-c1-2 ng-star-inserted ml-1">Upload Files</b>
                                <p class="mb-0 mt-2 drag-drop text-center">
                                    (Max. file size 10 MB)</p>
                            </div>
                          </div>
                        </span>
                        <span *ngIf="!isFileDragDropAvailable">click</span>
                    </ng-template>
                </file-upload>
            </div>
            <br>
        </div>
        <div class="uploaded-image" *ngIf="fileUploaded">
            <img [src]="image_url" alt="">
        </div>
    </div>
    <br>
    <div class="footer row container-fluid ">
        <div class=" margin-auto button">
            <button class="white mr-2" (click)="close()">Cancel</button>
            <button class="orange ml-2" (click)="uploadFile()">Save</button>
        </div>
    </div>
</div>